export default __webpack_public_path__ + "static/media/image9tum.f377ba56.jpg";